<div class="p-4">
  <h2 class="tw-mb-6 tw-text-xl tw-font-bold">
    {{ isViewOnly ? ('common.view' | translate) : ('raise.postNewAnnouncement' | translate) }}
  </h2>

  <form [formGroup]="form" [class.show-form-error]="showFormError">
    <div class="form-group tw-mb-4">
      <label class="tw-font-semibold">{{ 'raise.announcementTitle' | translate }}</label>
      <input
        class="form-control"
        formControlName="title"
        type="text"
        maxlength="200"
        placeholder="Enter announcement title"
        [readonly]="isViewOnly"
      />
      @if (showFormError && form.get('title').invalid) {
        <div class="tw-text-red-500 tw-mt-1 tw-text-xs">
          {{ 'raise.announcementTitleRequired' | translate }}
        </div>
      }
    </div>

    <div class="form-group tw-mb-4">
      <label class="tw-font-semibold">{{ 'common.audience' | translate }}</label>
      <mat-select
        [placeholder]="'common.selectPlaceholder' | translate"
        class="form-control"
        formControlName="audience"
      >
        @for (option of audienceOptions; track option) {
          <mat-option [value]="option.id">
            {{ option.labelKey | translate }}
          </mat-option>
        }
      </mat-select>
      @if (showFormError && form.get('audience').invalid) {
        <div class="tw-text-red-500 tw-mt-1 tw-text-xs">
          {{ 'common.audienceRequired' | translate }}
        </div>
      }
    </div>

    <div class="form-group tw-mb-6">
      <label class="tw-font-semibold">{{ 'raise.announcementContent' | translate }}</label>
      <textarea
        class="form-control"
        formControlName="body"
        maxlength="2000"
        placeholder="Enter announcement content"
        [readonly]="isViewOnly"
      ></textarea>
      @if (showFormError && form.get('body').invalid) {
        <div class="tw-text-red-500 tw-mt-1 tw-text-xs">
          {{ 'raise.announcementContentRequired' | translate }}
        </div>
      }
    </div>

    <div class="tw-mt-8 tw-flex tw-justify-end tw-gap-4">
      <button
        type="button"
        class="btn btn-link tw-text-gray-500 tw-no-underline"
        (click)="cancel()"
      >
        {{ 'common.cancel' | translate }}
      </button>
      @if (!isViewOnly) {
        <button
          type="button"
          class="btn btn-danger tw-bg-red-700 hover:tw-bg-red-800 tw-rounded tw-px-8 tw-font-semibold tw-text-white"
          [disabled]="isLoading"
          (click)="confirmSubmit()"
        >
          {{ 'common.confirm' | translate }}
        </button>
      }
    </div>
  </form>
</div>
